// extracted by mini-css-extract-plugin
module.exports = {"modalHeading":"registersuccess_modalHeading__H0Pmz","info":"registersuccess_info__URP3c"};